import { concat, flow, get, getOr, last, slice } from 'lodash/fp';
import { createSelector } from 'reselect';

import { getSearchUrl } from 'helpers/namedUrls';
import { LOCALE } from 'helpers/i18n';

const getItemsWithSearchUrl = createSelector(
  getOr([], ['items']),
  flow(
    concat({
      href: getSearchUrl(LOCALE),
      text: __('carDetails.searchLink'),
    }),
  ),
);

const getItems = createSelector(getItemsWithSearchUrl, slice(0, -1));

const getActiveText = createSelector(
  getItemsWithSearchUrl,
  flow(last, get(['text'])),
);

export default {
  activeText: getActiveText,
  items: getItems,
};
